import { Show } from './Show';
import { Create } from './Create';
import { ListLicenses as List } from './List';
import { Edit } from './Edit';

export { Show, Create, List, Edit }
export default { Show, Create, List, Edit }
